import { render } from "./AccountSubcontainer3.vue?vue&type=template&id=ffb1724a&scoped=true"
import script from "./AccountSubcontainer3.vue?vue&type=script&lang=js"
export * from "./AccountSubcontainer3.vue?vue&type=script&lang=js"

import "./AccountSubcontainer3.vue?vue&type=style&index=0&id=ffb1724a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ffb1724a"

export default script